export const addOfferToWishlist = (offerId, city, profile) => {
  const { wish_list: { cities } = {} } = profile;
  const wishlistItems = cleanWishlistItems(cities?.items);

  const doesCityExistInWishList = wishlistItems.some(({ city_slug }) => city_slug === city);
  if (doesCityExistInWishList) {
    return {
      cities: {
        items: wishlistItems.map(({ city_slug, accommodation_offer_ids }) => ({
          city_slug,
          accommodation_offer_ids: city_slug === city ? [...accommodation_offer_ids, offerId] : accommodation_offer_ids
        }))
      }
    };
  }

  return {
    cities: {
      items: [
        ...wishlistItems,
        {
          city_slug: city,
          accommodation_offer_ids: [offerId]
        }
      ]
    }
  };
};

export const removeOfferFromWishlist = (offerId, city, profile) => {
  const { wish_list: { cities } = {} } = profile;

  const wishlistItems = cities?.items || [];
  const updatedWishlistItems = wishlistItems.map(({ city_slug, accommodation_offer_ids }) => ({
    city_slug,
    accommodation_offer_ids:
      city_slug === city ? accommodation_offer_ids.filter(id => id !== offerId) : accommodation_offer_ids
  }));

  return {
    cities: {
      items: cleanWishlistItems(updatedWishlistItems)
    }
  };
};

const cleanWishlistItems = wishlistItems =>
  wishlistItems?.filter(({ accommodation_offer_ids }) => accommodation_offer_ids.length > 0) || [];
